/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export function customTabs(element) {
  var tabElements = element.querySelectorAll('.nav-link');
  for (var i = 0; i < tabElements.length; i++) {
    tabElements[i].addEventListener('click', function (e) {
      e.preventDefault();
      if (e.target.classList.contains('.active')) {
        element.classList.remove("show");
      } else {
        element.classList.toggle("show");
      }
    });
  }
}
export function customTabsInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var customTabsElements = container.querySelectorAll(".nav-tabs-dropdown");
  for (var i = 0; i < customTabsElements.length; i++) {
    customTabs(customTabsElements[i]);
  }
}